<div class="container">
  <h2>Policy File Management</h2>

  <div class="upload-section">
    <h3>Upload File</h3>
    <form [formGroup]="uploadForm" (ngSubmit)="submit()">
      <div class="form-group">
        <label for="file">File</label>
        <input type="file" id="file" (change)="onFileChange($event)" class="form-control">
      </div>
      <div class="form-group">
        <label for="type">Type</label>
        <select formControlName="type" id="type" class="form-control">
          <option *ngFor="let fileType of policyFileTypes" [value]="fileType">{{ fileType }}</option>
        </select>
      </div>
      <button type="submit" class="btn btn-primary">Upload</button>
    </form>
  </div>

  <div class="versions-section margin-top">
    <h3>File Versions</h3>
    <table class="table" *ngIf="fileVersions.length > 0">
      <thead>
      <tr>
        <th scope="col" class="text-center">#</th>
        <th scope="col" class="text-center">File name</th>
        <th scope="col" class="text-center">File type</th>
        <th scope="col" class="text-center">Type</th>
        <th scope="col" class="text-center">Version</th>
        <th scope="col" class="text-center">Active</th>
        <th scope="col" class="text-center">Deactivation date</th>
        <th scope="col" class="text-center">Upload date</th>
        <th scope="col" class="text-center">Modified date</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let version of fileVersions">
        <th class="text-center">{{ version.id }}</th>
        <td class="text-center">{{ version.fileName }}</td>
        <td class="text-center">{{ version.fileType }}</td>
        <td class="text-center">{{ version.type }}</td>
        <td class="text-center">{{ version.version }}</td>
        <td class="text-center">{{ version.active }}</td>
        <td class="text-center">{{ version.deactivationDate | date:'dd.MM.yyyy HH:mm:ss' }}</td>
        <td class="text-center">{{ version.uploadDate | date:'dd.MM.yyyy HH:mm:ss' }}</td>
        <td class="text-center">{{ version.modifiedDate | date:'dd.MM.yyyy HH:mm:ss' }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
